import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Sparkles, ArrowRight } from "lucide-react";
import ProfileCard from "@/components/dashboard/ProfileCard";
import ProfileDetailDialog from "@/components/dashboard/ProfileDetailDialog";

export default function HighlightsStrip({ sources = [], category = "", onSeeAll = () => {} }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detailId, setDetailId] = useState(null);

  const sourceColor = (key) => (sources.find((s) => s.key === key)?.color) || "#c8aa6e";

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/profiles", {
        params: { sort_by: "first_seen", sort_dir: "desc", page: 1, page_size: 10, category },
      });
      setItems(data.items || []);
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [category]);

  useEffect(() => { load(); }, [load]);

  if (!loading && items.length === 0) return null;

  return (
    <div className="bg-[#18181b] border border-[#27272a]" data-testid="highlights-strip">
      <div className="px-5 py-3 border-b border-[#27272a] flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-[#c8aa6e]" strokeWidth={1.5} />
          <span className="label-tiny">Novidades · perfis mais recentes</span>
        </div>
        <button
          type="button"
          onClick={onSeeAll}
          data-testid="highlights-see-all"
          className="inline-flex items-center gap-1 text-xs text-[#c8aa6e] hover:text-[#d4b982]"
        >
          Ver todos <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="p-4">
        {loading ? (
          <div className="flex gap-4 overflow-hidden">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="w-[180px] shrink-0 aspect-[4/5] bg-[#27272a]/40 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="flex gap-4 overflow-x-auto pb-2 snap-x" data-testid="highlights-scroll">
            {items.map((p, i) => (
              <div key={p.id} className="w-[180px] shrink-0 snap-start">
                <ProfileCard p={p} index={i} sourceColor={sourceColor(p.source)} onOpen={setDetailId} testid={`highlight-card-${i}`} />
              </div>
            ))}
          </div>
        )}
      </div>

      <ProfileDetailDialog
        profileId={detailId}
        open={!!detailId}
        onOpenChange={(o) => !o && setDetailId(null)}
      />
    </div>
  );
}
